<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="false"
    >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
        <Button v-if="nps.length > 0 && $can(abilities.CREATE_NPS)" btn-class="btn-md" type="new" btn-text="nps.new"  @click="handleCreatePress"/>
      </div>
    </template>
        <template #layoutContent> 
              <div class="row">
                <div v-if="nps.length > 0" class="row g-6 g-xl-9">
                  <NpsCard v-for="element in nps" :nps="element" :key="element.id"/>
                </div> 
                <div v-if="nps.length == 0 && !getting">
                  <Card class="card p-5 h-full">
                    <div class=" text-center ">
                      <div class="pt-8 ">
                        <Img filename="empty.png" alt=""
                            class="mw-100 h-125px h-sm-175px" />
                      </div>
                      <h2 class="fs-2x fw-bolder mb-0">{{ $t('nps.noNpsCreated') }}</h2>
                      <br>
                      <br>
                      <Button btn-class="btn-md" v-if="$can(abilities.CREATE_NPS)" type="new" btn-text="nps.createNewOne" @click="handleCreatePress"/>
                      <br>
                      <br>
                      <br>
                      <br>

                    </div>
                  </Card>
                </div>
              </div>        

        </template>
    </SubLayout>
</template>

<script setup>
import {computed, nextTick, onMounted, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import {useRouter, useRoute} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import {Theme} from "@/composables/theming";
import {useModelViewType} from "@/composables/modelViewType";
import NpsCard from "../../components/NpsCard.vue";
import Button from "@/components/Button.vue";
import Card from "@/components/Card.vue";
import abilities from "@/composables/abilities";
import Img from "@/components/Img.vue";

const route = useRoute()
const router = useRouter()

const store = useStore()
const { can } = useHasAbility()
const { locale } = useLocales()

const title = ref("breadcrumbs.nps")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.nps',
    route: 'nps-list'
  }
])

const nps = ref([])
const getting = ref(false)

async function loadNpsList() {
  getting.value = true
  await store.dispatch('nps/getNpsList').then((res) => {
    nps.value = res?.data?.data
  }).finally(() => {getting.value = false})
} 

const handleCreatePress = () => {
  router.push({name: "nps-create"})
}

onMounted(async() => {
  loadNpsList()
})

</script>

<style scoped>
  .password-input {
    position: relative;
  }

  .toggle-password {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  #eye-icon {
    font-size: 1.2em;
  }
</style>
